module.exports = __webpack_public_path__ + "static/media/Dyal Singh Building.827fb291.jpg";